// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-10-23T13:08:09Z                      #

// ##############################################################


/**
 * Stav podepisování.
 */
enum Status {
        INIT = 'INIT', 
        WAITING = 'WAITING', 
        SIGNING = 'SIGNING', 
        ERROR = 'ERROR', 
        CANCEL = 'CANCEL', 
        FINISH = 'FINISH'
};
export default Status;
